import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import { CompanyMemberNo } from '@models/Company';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchCompanyMemberNo = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: CompanyMemberNo) => {
      const response = await companyApis.patch('/dashboard/company/{id}/member-no/', {
        path: { id },
        body,
      });

      if (response[400]) {
        throw new FormError('PatchCompanyMemberId', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/member-no/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/detail/`]);
      },
    },
  );
};
